import { Collections } from "./components/collections/collections";
import { Families } from "./components/families/families";
import { Base } from "./filters.base";

export const Filters = Object.assign(Base, {
    Collections: Collections,
    Families: Families
});
